module.exports = __webpack_public_path__ + "../../../static/img/c_im_16.39c2dc1a.png";